import PropTypes from 'prop-types';
import { creatorType } from '~/types/creator';

export const ytChannelType = PropTypes.shape({
  id: PropTypes.string,
  ytChannelId: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  publishedAt: PropTypes.string,
  viewCount: PropTypes.number,
  commentCount: PropTypes.number,
  subscriberCount: PropTypes.number,
  hiddenSubscriberCount: PropTypes.bool,
  videoCount: PropTypes.number,
  active: PropTypes.bool,
  thumbnails: PropTypes.shape({
    default: PropTypes.shape({
      url: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number,
    }),
    medium: PropTypes.shape({
      url: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number,
    }),
    high: PropTypes.shape({
      url: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number,
    }),
  }),
  creator: creatorType,
  ytContents: PropTypes.array,
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string,
});
